import type * as React from 'react'
import { withRouter } from '@/app/navigation/withRouter'

/**
 * In v6, paths inside a descendant `<Routes>` must be relative to the parent's
 * matched URL. Our route configs store absolute paths; use `toRelativeRoute`
 * to strip the module's mount prefix at the call site.
 */
export function toRelativeRoute(absolutePath: string, modulePath: string): string {
  const stripped = absolutePath.startsWith(modulePath)
    ? absolutePath.slice(modulePath.length)
    : absolutePath
  return stripped.replace(/^\//, '') || '/'
}

/**
 * Wrap a module's route components with the `withRouter` shim once, at module
 * load. Calling `withRouter(route.component)` inside `.map()` during render
 * returns a new component type each render, which causes React to unmount and
 * remount the page on every parent render — a quick path to infinite fetch
 * loops in effects.
 */
export function wrapRoutesWithRouter<R extends { component: React.ComponentType<any> }>(
  routes: R[],
): (R & { Component: React.ComponentType<any> })[] {
  return routes.map((route) => ({ ...route, Component: withRouter(route.component) }))
}
